import { encodePaginatableQuery, encodeSortableQuery, PaginatableQuery, Query, SortableQuery } from '@/services/api';
import * as q from '@/services/api/request/query';

export interface EntityTypeQuery extends PaginatableQuery, SortableQuery {
  search: string;
  entityTypeIds?: number[];
}

export const encodeEntityTypeQuery = (query: EntityTypeQuery): Query => ({
  ...encodePaginatableQuery(query),
  search: q.string(query.search),
  ...encodeSortableQuery(query),
  ...(query.entityTypeIds ? { entity_type_ids: q.numbers(query.entityTypeIds) } : {}),
});

export const entityTypeDefaultQuery = () => ({
  page: 1,
  perPage: 10000,
  search: '',
  dir: '',
  sort: '',
});
